import { render, staticRenderFns } from "./form2-item-input.vue?vue&type=template&id=e3d5ad8a&scoped=true&"
import script from "./form2-item-input.vue?vue&type=script&lang=js&"
export * from "./form2-item-input.vue?vue&type=script&lang=js&"
import style0 from "./form2-item-input.vue?vue&type=style&index=0&id=e3d5ad8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d5ad8a",
  null
  
)

export default component.exports